import { IMAGE_COMPARE__image_a } from './image_a/IMAGE_COMPARE__image_a';
import { BUTTON__image_a_clear } from './ui/BUTTON__image_a_clear';
import { BUTTON__image_compare_close } from './ui/BUTTON__image_compare_close';
import { CHECKBOX__use_image_a_aspect_ratio } from './ui/CHECKBOX__use_image_a_aspect_ratio';
import { DROPDOWN__image_compare_mode } from './ui/DROPDOWN__image_compare_mode';

export function SIDEBAR__image_compare() {
  return (
    <div
      className={`w-full flex-1 flex flex-col gap-2
    px-2 py-1
    bg-bar min-w-0 min-h-0`}
    >
      <BUTTON__image_compare_close />
      <DROPDOWN__image_compare_mode />
      <CHECKBOX__use_image_a_aspect_ratio />
      <IMAGE_COMPARE__image_a />
      <BUTTON__image_a_clear />
    </div>
  );
}
